import { render, staticRenderFns } from "./masrafmerkezicomp.vue?vue&type=template&id=40a771bc&"
import script from "./masrafmerkezicomp.vue?vue&type=script&lang=js&"
export * from "./masrafmerkezicomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports